import { createAction } from '@reduxjs/toolkit';

// Global reset action for clearing all user data on logout/401
export const globalReset = createAction('GLOBAL_RESET');
